import * as React from "react"
import * as styles from '../styles/official_sns_section.module.css'
import { Header1 } from "./heading_elements";
import { OfficialTwitterX } from "./social"

export function OfficialSnsSection() {
    return (
        <section className={styles.section_sns}>
          <Header1 headerTitle={"公式ＳＮＳ"}></Header1>
          <p className={styles.section_sns_text}>フォローして最新情報を入手しよう</p>
          <OfficialTwitterX handle={"IrisOdysseyJP"}/>
        </section>
    )
}